import cn from "classnames";
import {ExclamationMarkNotificator} from "@game/ui/components/Notificator/ExclamationMarkNotificator";
import {ComponentClassName} from "@dp-instant/ui";

export type ShopTabHeaderProps = {
    title?: string;
    showNotification?: boolean;
    onClick?: () => void;
} & ComponentClassName;

export const ShopTabHeader = ({
    className = "",
    title = "Test",
    showNotification = false,
    onClick = () => {}
}: ShopTabHeaderProps) => {
    return (
        <div onClick={onClick} className={cn("shop-menu__tab-header", className)}>
            <span>{title}</span>
            {showNotification ? (
                <div>
                    <ExclamationMarkNotificator
                        className={cn(
                            "exclamation-mark-notificator_top-right",
                            "exclamation-mark-notificator_animated"
                        )}
                    />
                </div>
            ) : null}
        </div>
    );
};
